import React from 'react';

import {
  UniversalNameScreen,
  UniversalNameScreenConfig,
} from '@/pages/Onboarding/Layouts/screens/UniversalNameScreen';

export const compatibilityNameScreenConfig: UniversalNameScreenConfig = {
  backgroundImage: '/assets/own-ai-compatibility/name/background.png',
  backgroundTheme: 'dark-solid',

  messages: {
    initial: {
      content: 'How should I call you, stranger?',
      variant: 'received',
    },
    userResponse: {
      content: '', // Will be replaced with actual userName
      variant: 'sent',
    },
    followUp: [
      {
        content: 'Nice to meet you, ${userName}..',
        variant: 'received',
      },
      {
        content: "I feel like we're meant to meet 💋",
        variant: 'received',
      },
    ],
  },

  buttonText: 'Keep it going',
};

export const NameScreen: React.FC = () => {
  return <UniversalNameScreen config={compatibilityNameScreenConfig} />;
};
